import { ca } from '@cian/analytics';

import { IPromoInfoSchema } from '../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { getNewbuildingProduct } from '../../utils/analytics';

export function trackGetOnlineClick(promo: IPromoInfoSchema, position: number, newbuildingId: number) {
  const { promoType, promoId, uniquePromoId } = promo;

  ca('eventSite', {
    action: 'click_get_online',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [
      getNewbuildingProduct({ newbuildingId, extra: { promoId, promoCianMortgage: uniquePromoId, position } }),
    ],
  });
}
